import { Controller } from "@hotwired/stimulus"

/**
 * Dropdown controller for the reporting V2 top-nav account selector.
 * Toggles a dropdown panel, closes on outside click/Escape, and
 * provides inline search filtering of account links.
 */
export default class extends Controller {
  static targets = ["menu", "search", "item"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")
    if (!this.menuTarget.classList.contains("hidden")) {
      if (this.hasSearchTarget) {
        setTimeout(() => this.searchTarget.focus(), 0)
      }
      // Scroll to the selected account
      this._scrollToSelected()
    }
  }

  _scrollToSelected() {
    const selected = this.itemTargets.find(item =>
      item.classList.contains("bg-sg-green")
    )
    if (selected) {
      setTimeout(() => {
        selected.scrollIntoView({ block: "center" })
      }, 0)
    }
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase().trim()
    this.itemTargets.forEach(item => {
      const text = item.textContent.toLowerCase()
      item.classList.toggle("hidden", query.length > 0 && !text.includes(query))
    })
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.menuTarget.classList.add("hidden")
    }
  }

  connect() {
    this._outsideClick = this.close.bind(this)
    this._escape = this.closeOnEscape.bind(this)
    document.addEventListener("click", this._outsideClick)
    document.addEventListener("keydown", this._escape)
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClick)
    document.removeEventListener("keydown", this._escape)
  }
}
